import { useEffect, useState, useRef } from 'react';
import { WebSocketService, type WebSocketData } from '../services/WebSocketService';
import { sendWebSocketSubscribe, sendWebSocketUnsubscribe } from '@/utils';

export const useWebSocketService = (topic: string): WebSocketData => {
  const [state, setState] = useState<WebSocketData>(() => WebSocketService.getState());
  const isSubscribedRef = useRef(false);

  useEffect(() => {
    // Prevent multiple subscriptions from the same component instance
    if (isSubscribedRef.current) {
      console.log('useWebSocketService: Already subscribed, skipping...');
      return;
    }

    console.log('useWebSocketService: Effect running - subscribing to WebSocket');
    isSubscribedRef.current = true;
    
    // Subscribe to WebSocket updates
    const unsubscribe = WebSocketService.subscribe(setState);

    // Start connection if not already connected
    WebSocketService.connect(() => {
      const success = sendWebSocketSubscribe(topic);
      if (success) {
        console.log('Subscription payload sent successfully');
      } else {
        console.warn('Failed to send subscription payload - WebSocket not connected or no token');
      }
    });

    // Cleanup on unmount
    return () => {
      console.log('useWebSocketService: Effect cleanup - unsubscribing from WebSocket');
      isSubscribedRef.current = false;
      const success = sendWebSocketUnsubscribe(topic);
      if (success) {
        console.log('Subscription payload sent successfully');
      } else {
        console.warn('Failed to send subscription payload - WebSocket not connected or no token');
      }
      unsubscribe();
      WebSocketService.disconnect();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this only runs once

  return state;
};
